/**
 * Retrieves a specific recipe setting based on the provided setting ID.
 *
 * @param {String} settingID - The ID of the setting to retrieve.
 * @return {*} The value of the specified setting, or `undefined` if the setting ID is not recognized.
 */
const getRecipeSetting = settingID => {
	switch ( settingID ) {
		case 'recipe_throttle':
			return UncannyAutomator._recipe.miscellaneous.recipe_throttle;

		case 'recipe_total_times':
			return UncannyAutomator._recipe.miscellaneous.recipe_total_times;

		case 'recipe_times_per_user':
			return UncannyAutomator._recipe.miscellaneous.limit_per_user;

		case 'recipe_user_type':
			return {
				'USER_TYPE': {
					value: UncannyAutomator._recipe.recipe_type
				}
			};

		case 'recipe_created_on':
			return {
				'CREATED_ON': {
					value: UncannyAutomator._recipe.miscellaneous.created_on_date
				}
			};

		case 'recipe_completed_runs':
			return {
				'COMPLETED_RUNS': {
					value: UncannyAutomator._recipe.stats.total_runs
				}
			};
	}
}

export default getRecipeSetting;
